import { Component, OnInit } from '@angular/core';
//import { DownloadFileService } from '../../services/file-transfers/download-file.service';
import * as fileSaver from 'file-saver';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-download-file',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.scss']
})
export class DownloadFileComponent {

  title = 'Angular File Download';

  constructor() { }//(private downloadFileService: DownloadFileService) { }

  download() {
    //this.downloadFileService.downloadFile().subscribe(response => {
    //  let blob:any = new Blob([response], { type: 'text/json; charset=utf-8' });//Expecetd file type and content type
    //  const url= window.URL.createObjectURL(blob);
    //  //window.open(url);
    //  window.location.href = url;
    //  //fileSaver.saveAs(blob, 'employees.json');
    //}), error => console.log('Error downloading the file'),
    //  () => console.info('File downloaded successfully');
  }



  showPdfDocument() {
    let filename: string = 'document.pdf';
    //this.downloadFileService.getFile(filename).then((result: any) => {
    //  this.showFile(result._body, filename);
    //});
  }

  private showFile(blob: any, filename: string) {
    // It is necessary to create a new blob object with mime-type 
    // explicitly set otherwise only Chrome works like it should
    let newBlob = new Blob([blob], { type: "application/pdf" });

    // IE doesn't allow using a blob object directly as link href 
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    let data = window.URL.createObjectURL(newBlob);
    let link = document.createElement('a');
    link.href = data;
    link.download = filename;
    link.click();
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 100);
  }

}
